import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

import "./styles/TicketBottom.css"

const TicketBottom = ({children, className}) => {
  return (
    <div className={classNames("tickets_bottom", className)}>
      <div className="tickets_bottomInner">{children}</div>
    </div>
  )
}

TicketBottom.defaultProps = {
  children: null,
  className: null
}

TicketBottom.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string
}

export default TicketBottom
